module.exports = __webpack_public_path__ + "static/img/5areaB_1.48cc81a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/5areaB_1.png
// module id = 1190
// module chunks = 1